<template>
  <div style="width: 100%">
    <v-row dense>
      <v-divider/>
    </v-row>
    <v-expansion-panels multiple class="mt-2 mb-4" accordion flat focusable v-model="panel">
      <r-item-panel :items.sync="value.items" title="Items" :amount="true"/>
      <r-currency-panel :items.sync="value.money" title="Currency"/>
      <r-reward-package-panel :items.sync="value.packages" title="Packages"/>
      <r-card-panel :items.sync="value.cards" title="Cards"/>
      <r-card-package-panel :items.sync="value.cardPackages" title="Card Packages"/>
      <r-currency-correction-panel :items.sync="value.currencyCorrection" title="Currency Correction"/>
    </v-expansion-panels>
    <v-row dense>
      <v-divider/>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="6" sm="6">
        <r-avatar-dropdown :model.sync="model.avatar" :clearable="true"/>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import VueTypes from "vue-types";
import {StashBonusBunch} from "@/modules/redactor/models/stash/StashBonusBunch";

import RAvatarDropdown from "@/modules/redactor/views/avatar/r-avatar-dropdown.vue";
import RCardPanel from "@/modules/redactor/views/card/r-card-panel.vue";
import RItemPanel from "@/modules/redactor/views/item/r-item-panel.vue";
import RCurrencyPanel from "@/modules/redactor/views/currency/r-currency-panel.vue";
import RRewardPackagePanel from "@/modules/redactor/views/reward-pack/r-reward-package-panel.vue";
import RCardPackagePanel from "@/modules/redactor/views/card-package/r-card-package-panel.vue";
import RCurrencyCorrectionPanel from "@/modules/redactor/views/currency/r-currency-correction-panel.vue";

export default {
  name: "r-stash-bonus-bunch-view",
  components: {
    RCardPackagePanel,
    RItemPanel,
    RCurrencyPanel,
    RRewardPackagePanel,
    RCardPanel,
    RCurrencyCorrectionPanel,
    RAvatarDropdown
  },
  props: {
    model: VueTypes.instanceOf(StashBonusBunch)
  },
  data: () => ({
    panel: []
  }),
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new StashBonusBunch();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  watch: {
    model: {
      immediate: true,
      handler(data) {
        this.panel = [];

        if (data.items.length > 0) {
          this.panel.push(0);
        }

        if (data.money.length > 0) {
          this.panel.push(1);
        }

        if (data.packages.length > 0) {
          this.panel.push(2);
        }

        if (data.cards.length > 0) {
          this.panel.push(3);
        }

        if (data.cardPackages.length > 0) {
          this.panel.push(4);
        }

        if (data.currencyCorrection.length > 0) {
          this.panel.push(5);
        }
      }
    }
  },
}
</script>
